/**
 * Event Handlers Module
 * Centralized DOM event listener setup and handler functions for the portal application
 */

import type { EventHandlerDeps } from './eventHandlers/globalEventTypes';
import { setupKeyboardHandlers } from './eventHandlers/keyboardHandlers';
import { setupModalLifecycleHandlers } from './eventHandlers/modalLifecycleHandlers';
import { setupRowInteractionHandlers } from './eventHandlers/rowInteractionHandlers';
import { setupSubscriptionExtensionHandlers } from './eventHandlers/subscriptionExtensionHandlers';

/**
 * Setup all DOM event listeners for the portal
 */
export function setupEventHandlers(deps: EventHandlerDeps): void {
  setupModalLifecycleHandlers(deps);
  setupSubscriptionExtensionHandlers(deps);
  setupKeyboardHandlers();
  setupRowInteractionHandlers(deps);
}
